import { APP_URL } from 'config';

export enum TerritorySettingsSubpage {
  overview = 'overview',
  membership = 'membership',
  dangerZone = 'danger-zone',
}

export enum TerritorySettingsSubpageTitle {
  overview = 'Overview',
  membership = 'Membership Roles',
  dangerZone = 'Danger Zone',
}

export const TERRITORY_SETTINGS_MAX_ROLES_COUNT = 5;

export const TERRITORY_MONETIZATION_EXPLAINED_URL = `${APP_URL}/article/cm3n6bwsi6981711ymc3sntl3dd`;
